import React from 'react';
import { useTranslation } from 'react-i18next';

import { DenominationBagType } from '@components';

import styles from '../DenominationLadder/DenominationLadder.module.scss';

interface DenominationLadderTableHeaderProps {
  bagType: DenominationBagType;
  readOnly: boolean;
}

const languageNamespace = 'denomination-ladder';

export const DenominationLadderTableHeader = ({
  bagType,
  readOnly,
}: DenominationLadderTableHeaderProps): JSX.Element => {
  const { t } = useTranslation(languageNamespace);

  return (
    <thead className={styles.header}>
      <tr className={readOnly ? styles.textLeft : styles.textCenter}>
        <th className={styles.headerCol}>{t('denomination')}</th>
        {!readOnly && <th className={styles.headerCol}></th>}
        {bagType !== DenominationBagType.unknown ? (
          <>
            <th className={styles.headerCol}>{t('noOfBags')}</th>
            {bagType === 'partBag' && <th className={styles.headerCol}>{t('looseCoins')}</th>}
          </>
        ) : (
          <th className={styles.headerCol}>{t('quantity')}</th>
        )}
        {!readOnly && <th className={styles.headerCol}></th>}
        <th className={styles.headerCol}>{t('value')}</th>
      </tr>
    </thead>
  );
};
